import React, { useState } from "react";
import "./Sugerido.css";

function InventarioNormalizado() {
  const [catalogo, setCatalogo] = useState(null);
  const [inventario, setInventario] = useState(null);
  const [sucursal, setSucursal] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!catalogo || !inventario || !sucursal) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("catalogo", catalogo);
    formData.append("inventario", inventario);
    formData.append("sucursal", sucursal);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/sugerido/normaliza-inventario/`, {
      method: "POST",
      body: formData,
    });

    if (res.ok) {
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Formato Sugerido.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }
    setLoading(false);
  };

  return (
    <div className="normalizar-inventario-container">
      <h2>Creación de Sugerido</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="sucursal-input" style={{ display: "block", textAlign: "left", marginBottom: "4px", marginLeft: "8px", fontWeight: "bold" }}>
          Sucursal:
        </label>
        <input
          id="sucursal-input"
          type="text"
          value={sucursal}
          onChange={e => setSucursal(e.target.value)}
          required
          className="input-normalizado"
          placeholder="Ejemplo: 050"
        />
        <label htmlFor="catalogo-input" style={{ display: "block", textAlign: "left", marginBottom: "4px", marginLeft: "8px", fontWeight: "bold" }}>
          Catálogo:
        </label>
        <input
          id="catalogo-input"
          type="file"
          accept=".xlsx,.xls"
          onChange={e => setCatalogo(e.target.files[0])}
          required
          className="input-normalizado"
        />
        <label htmlFor="inventario-input" style={{ display: "block", textAlign: "left", marginBottom: "4px", marginLeft: "8px", marginTop: "12px", fontWeight: "bold" }}>
          Existencias:
        </label>
        <input
          id="inventario-input"
          type="file"
          accept=".xlsx,.xls"
          onChange={e => setInventario(e.target.files[0])}
          required
          className="input-normalizado"
        />
        <button type="submit" disabled={loading} className="btn-normalizado">
          {loading ? "Procesando..." : "Subir"}
        </button>
      </form>
    </div>
  );
}

export default InventarioNormalizado;